import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Store } from '@ngrx/store';
import { IPageData } from '../../../interfaces/page-data';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import * as PageActions from '../../../store/actions/page.actions';
import { Options } from 'ng5-slider';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { interval, Observable} from 'rxjs'
import { ActivatedRoute, Router } from '@angular/router';
import { Spinkit } from 'ng-http-loader'; // <============
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'order-list-page',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent extends BasePageComponent implements OnInit, OnDestroy {

  iconmenu = './assets/img/menu.svg';
  iconAtvmenu = './assets/img/greymenu.svg';

  iconcart = './assets/img/green_cart.svg';
  iconAtvcart = './assets/img/cart.svg';

  iconorder = './assets/img/green_orders.svg';
  iconAtvorder = './assets/img/order.svg';

  iconprofile = './assets/img/greenprofile.svg';
  iconAtvprofile = './assets/img/profile.svg';

  loadingBasicForm: boolean;
  pageData: IPageData;
  value: number = 0;
  public spinkit = Spinkit;
  errorMessage
  restoID;
  toggle;
  allergenceArray = []
  diestPrefArray = []
  changeColorallergens = [];
  changeColordiet = []
  changeColors = []
  showmenus = '1'
  searchText
  allDietDatas
  allAllergDatas = []
  products: any
  totalcartvalue = 0;
  valueOrder
  conditionToDisaply
  orders = []
  dishes = []
  UserCondition
  token
  ids
  tableids
  ordersummary: boolean = false
  orderReview: boolean = false
  usersOrderData = []
  userOrdercompletedData = []
  singleOrderdata
  orderTotalPrice
  orderStatus
  orderDishes = []
  foodDishesName
  orderItemQuantity
  orderItemSinglePrice
  allAllergReviewvalue
  allAllergReviewvalueStatus
  OrderNo
  orderDetails = []
  UesrCC
  finalSPICE = []
  starratings
  allergenscomment
  tastecomment
  safevalue = '0'
  spicerate
  orderNo
  orderId
  dishId
  name
  userName
  orderItemId
  alleregens_rating_code
  // public totalSubject = new Subject()
  // public orderSubject = new Subject()
  userName_loggedin;
  user_Name: any;
  cartLength
  length
  counts
  sub
  lengths

  constructor(store: Store<IAppState>,
    httpSv: HttpService, private router: Router,
    private fb: FormBuilder,
    private _bottomSheet: MatBottomSheet,
    private route: ActivatedRoute,
    private _location: Location) {
    super(store, httpSv);

    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [{
        title: '',
        route: 'order-list'
      }]
    };



  }
  noOrders: boolean = false;
  ordersData: any[] = []
  userNotYetOrdered: boolean = false;
  userOrdered: boolean = false;
  ngOnInit() {
    // this.userNotYetOrdered = true;
    this.ordersData = JSON.parse(sessionStorage.getItem('orders-data'));
    if (this.ordersData?.length) {
      this.userOrdered = true;
    } else {
      this.userNotYetOrdered = true;
    }
    this.restoID = sessionStorage.getItem("restoId")
    this.token = sessionStorage.getItem('access_token')
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.route.queryParams.subscribe(params => {
      this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.getAllUserorders();
    this.sub = interval(500)
    .subscribe((val) => {
      this.cartLength = sessionStorage.getItem('orders-data');
      this.length = JSON.parse(this.cartLength)
      this.counts = this.length?.map((item: any) => {
        return item.indexVal
      })
      this.lengths = this.counts?.length
    });
   

    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
  }

  reviewForm = this.fb.group({
    starratings: ['', Validators.required],
    tastetext: ['']
  })
  reviewForAlleryForm = this.fb.group({
    allergenstext: ['', Validators.required],
    starratings: ['', Validators.required],
    tastetext: ['']
  });



  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }

  ngOnChanges(): void {
    if (this.cartLength) {
      this.sub = interval(500)
        .subscribe((val) => {
          this.cartLength = sessionStorage.getItem('orders-data');
          this.length = JSON.parse(this.cartLength)
          this.counts = this.length?.map((item: any) => {
            return item.indexVal
          })
          this.lengths = this.counts?.length
        });
    }
    else {
      this.counts = 0;
    }
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], {
            queryParams: {
              id: this.ids,
              table_id: this.tableids
            }
          });
        } else {
          Swal.fire("Something Went Wrong")
        }

      }
    )
  }

  backHomeUser() {
    this.router.navigate(['/horizontal/resto'])
  }
  backHomeGuest() {
    this.router.navigate(['/public/resto'])
  }
  backTologin() {
    this.router.navigate(['/public/sign-in']);
    sessionStorage.setItem("guestToOrders", "true")
  }
  backClicked() {
    this._location.back();
  }
  viewSummary(orderId) {
    this.ordersummary = true
    this.orderReview = false
    this.ngOnInit();
    this.httpSv.singleUserOrderhistory(orderId).subscribe(
      response => {
        if (response['status'] == true) {
          this.singleOrderdata = response['result'].data
          this.orderDetails.push(this.singleOrderdata)
          this.orderDetails.forEach((ele) => {
            this.spicerate = ele.user_preference_spice
            const numberSpice = parseInt(this.spicerate)
            for (let i = 0; i < numberSpice; i++) {
              this.finalSPICE.push(i)
            }
          })
          this.OrderNo = response['result'].data.order_no
          this.orderStatus = response['result'].data.order_status
          this.orderTotalPrice = response['result'].data.order_total_price
          this.orderDishes = response['result'].data.order_dishes
          for (let i = 0; i < this.orderDishes.length; i++) {
            this.foodDishesName = this.orderDishes[i].food_dishes_name
            this.orderItemQuantity = this.orderDishes[i].order_item_quantity
            this.orderItemSinglePrice = this.orderDishes[i].order_item_single_price
          }
          this.UesrCC = response['result'].data.user_preference_cc
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        swal.fire({
          titleText: this.errorMessage,
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
          position: "top-right",
        })
      }
    )
  }

  backToOrders() {
    this.ordersummary = false
    this.orderReview = false
    this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      this.router.navigate(['horizontal/order-list']);
    });
  }


  orderHistorydata() {
    this.httpSv.orderHistorydata().subscribe(
      response => {
        if (response['status'] == true) {
          this.usersOrderData = response['result'].data
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
      }
    )
  }
  coupanwith_price
  orderHistoryCompleteddata() {
    this.httpSv.orderHistoryCompleteddata().subscribe(
      response => {
        if (response['status'] == true) {
          this.userOrdercompletedData = response['result'].data

        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
      }
    )
  }

  counter(i) {
    return new Array(i)
  }
  spiecvalue(j) {
    let spicevar = []
    for (let i = 0; i < j; i++) {
      spicevar.push(j)
    }
    return spicevar
  }

  checkAllergences(allergenceList) {
    if (typeof allergenceList.user_preference_allergens == 'object' && Array.isArray(allergenceList.user_preference_allergens) && Object.keys(allergenceList.user_preference_allergens).length)
      return true;

    return false;
  }

  checkDietary(allergenceList) {
    if (typeof allergenceList.user_preference_dietary == 'object' && Array.isArray(allergenceList.user_preference_dietary) && Object.keys(allergenceList.user_preference_dietary).length)
      return true;

    return false;
  }
  onUnsafe() {
    this.safevalue = '1'
  }

  onSafe() {
    this.safevalue = '0'

  }
  allergen_value(obj) {
    return Array.prototype.map.call(obj, s => s.allergens_name).toString();
  }
  dietary_value(obj) {
    return Array.prototype.map.call(obj, s => s.diet_preference_name).toString();
  }
  onReview(orderNo, orderId, dishID, name, orderItemId) {
    this.ordersummary = false
    this.orderReview = true
    this.orderNo = orderNo
    this.orderId = orderId
    this.dishId = dishID
    this.name = name
    this.orderItemId = orderItemId


    this.httpSv.allergensOrderReviewCheck(this.orderId, this.dishId).subscribe(
      response => {
        if (response['status'] == true) {
          this.allAllergReviewvalueStatus = response['status']
        }

      }, (err: HttpErrorResponse) => {
        this.allAllergReviewvalueStatus = err.error.status
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })

        }
        else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
      }
    )
  }

  onSubmitReview() {
    this.allergenscomment = 'It safe to Eat';
    this.allAllergReviewvalue = 'Safe'
    this.httpSv.postReview(this.orderId, this.dishId, this.restoID, this.orderItemId, this.reviewForm.value.starratings,
      this.reviewForm.value.tastetext, this.allAllergReviewvalue, this.allergenscomment).subscribe(
        response => {
          if (response['status'] == true) {
            let sheetRef = this._bottomSheet.open(BottomSheetOrderlistReview, {
              data: response['message']
            });
            sheetRef.afterDismissed().subscribe(data => {
              location.reload();
            });
            this.reviewForm.reset();
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message
          Swal.fire({
            title: this.errorMessage
          }
          );
          if (err.status == 422) {
            this.errorMessage = err.error.message.test_score_code ? err.error.message.test_score_code : "";
            this.errorMessage += err.error.message.test_score_text ? err.error.message.test_score_text : "";
            this.errorMessage += err.error.message.order_id ? err.error.message.order_id : "";
            this.errorMessage += err.error.message.dish_id ? err.error.message.dish_id : "";
            this.errorMessage += err.error.message.restaurant_id ? err.error.restaurant_id : "";
            this.errorMessage += err.error.message.order_item_id ? err.error.message.order_item_id : "";
            Swal.fire({
              title: this.errorMessage
            }
            );
          }
          if (err.status == 401) {
            this.logout();
            swal.fire({
              titleText: this.errorMessage,
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
              position: "top-right",
            })

          }
          else if (err.status == 500) {
            this.logout();
            swal.fire({
              titleText: this.errorMessage,
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
              position: "top-right",
            })
          }
        });
  }
  onSubmitforAlleryReview() {
    this.allAllergReviewvalue = 'Unsafe'
    this.httpSv.postReview(this.orderId, this.dishId, this.restoID, this.orderItemId, this.reviewForAlleryForm.value.starratings,
      this.reviewForAlleryForm.value.tastetext, this.allAllergReviewvalue, this.reviewForAlleryForm.value.allergenstext).subscribe(
        response => {
          if (response['status'] == true) {
            let sheetRef = this._bottomSheet.open(BottomSheetOrderlistReview, {
              data: response['message']
            });
            sheetRef.afterDismissed().subscribe(data => {
              location.reload();

            });
            this.reviewForAlleryForm.reset();
          }

        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message
          Swal.fire({
            title: this.errorMessage
          }
          );
          if (err.status == 422) {
            this.errorMessage = err.error.message.test_score_code ? err.error.message.test_score_code : "";
            this.errorMessage += err.error.message.test_score_text ? err.error.message.test_score_text : "";
            this.errorMessage += err.error.message.order_id ? err.error.message.order_id : "";
            this.errorMessage += err.error.message.dish_id ? err.error.message.dish_id : "";
            this.errorMessage += err.error.message.restaurant_id ? err.error.restaurant_id : "";
            this.errorMessage += err.error.message.order_item_id ? err.error.message.order_item_id : "";
            Swal.fire({
              title: this.errorMessage
            }
            );
          }
          if (err.status == 401) {
            this.logout();
            swal.fire({
              titleText: this.errorMessage,
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
              position: "top-right",
            })

          }
          else if (err.status == 500) {
            this.logout();
            swal.fire({
              titleText: this.errorMessage,
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false,
              position: "top-right",
            })
          }
        });
  }

  value_coupon(val) {
    return parseFloat(val).toFixed(2);
  }

  goToMenu() {
    this.router.navigate(['/vertical/food-menu'])
  }

  placedOrdersArray : any[] = [];
  getAllUserorders() {
    let getOrdersObj = {
      order_status: "Completed"
    }
    console.log(getOrdersObj)
    this.httpSv.getAllPlacedOrders(getOrdersObj).subscribe((res:any)=> {
     if(res['status'] == 'TRUE') {
      this.placedOrdersArray = res['result'].data;
      if(this.placedOrdersArray.length == 0) {
        this.noOrders = true;
      }
     }
    },(err:any)=> {
      console.log(err);
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }

  OrderDetails :any[] = [];
  orderDetailsorderId
  getDishOrderDetails() {
    this.httpSv.getOrderDetails(this.orderId).subscribe((res:any)=> {
      if (res['status'] == "TRUE") { 
        this.OrderDetails = res['result'].data.order_dishes;
        this.orderDetailsorderId = res['result'].data.order_id;
      }
    },(err:any)=> {
      console.log(err);
    })
  }

  OrderPlaced : boolean = false;
  totalPrice
  restoName
  showParticularOrderDetails(ordId) {
    this.orderId = ordId;
    this.httpSv.getOrderDetails(ordId).subscribe((res:any)=> {
      if (res['status'] == "TRUE") { 
        this.restoName = sessionStorage.getItem("restoName");
        this.OrderDetails = res['result'].data.order_dishes;
        this.orderDetailsorderId = res['result'].data.order_id;
        this.totalPrice = res['result'].data.total_price;
        this.OrderPlaced = true;
      }
    },(err:any)=> {
      console.log(err);
    })
  }

  goToOrdersHistory () {
    this.OrderPlaced = false;
  }

  goToPostReview(foodDishName,ordId,ordItemId,dishId) {
   let queryParamsArray = [ 
    {
    dishname : foodDishName,
    id :ordId ,
    ordItemId:ordItemId,
    dishId:dishId
  }
]
    this.router.navigate(['/vertical/post-review'],{
      queryParams: {
        filter: JSON.stringify(queryParamsArray)
    }
    })
  }

  getLoginScreen() {
  //   if (this.UserCondition) {
  //     this.UserCondition = true;
  //     this.router.navigate(['/horizontal/food-menu'])
  //   } else {
  //     let sheetRef = this._bottomSheet.open(BottomSheetFoodGuestLogin, {
  //       disableClose: true
  //     });
  //     sheetRef.afterDismissed().subscribe((dataFromChild) => {
  //       if (dataFromChild) {
  //         this.ngOnInit();
  //       }
  //     });
  //   }
  }
}

@Component({
  selector: 'bottom-sheet-orderlist-review',
  templateUrl: 'bottom-sheet-orderlist-review.html',
})
export class BottomSheetOrderlistReview implements OnInit {
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<BottomSheetOrderlistReview>, public httpSv: HttpService) { }
  dataSource = this.data;
  maindata
  datas
  restoID
  values: number = 0;
  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
  ngOnInit() {
  }

}





